import React from "react";
import {connect} from "react-redux";
import Assistance from "../components/Assistance";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

const AssistanceContainer = () => {
    return (
        <div>
            <Assistance/>
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(AssistanceContainer);


// WEBPACK FOOTER //
// ./src/container/AssistanceContainer.js